import { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { getFaq, updateFaq } from "../../../api/boardFaq.api";
import ErrorResponse from "../../../components/ErrorResponse";
import FaqEditor from "../../../components/homepage/faq/Editor";
import SimpleHeader from "../../../components/layout/SimpleHeader";
import Loader from "../../../components/Loader";
import useAxios from "../../../hooks/useAxios";
import useNotification from "../../../hooks/useNotification";
import { IGetFaq } from "../../../models/boardFaq.model";

interface IMatch {
  faqCode: string;
}

const HomepageFaqEdit = () => {
  const { t } = useTranslation();
  const match = useRouteMatch<IMatch>();
  const faqCode = Number(match.params.faqCode);
  const history = useHistory();
  const location = useLocation();
  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetFaq>();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios();

  useEffect(() => {
    if (faqCode) {
      execute(getFaq(faqCode));
    }
  }, [faqCode]);

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      successNotification(t('common.message.save1'));
      history.push(`/homepage/faq${location.search}`);
    }
  }, [submitRes, submitIsLoading]);

  const submit = (data: FormData) => {
    if (!faqCode) return;
    submitExecute(updateFaq(faqCode, data));
  }

  return (
    <div className="content scrollbar">
      {isLoading || submitIsLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={submitError} />
      <SimpleHeader
        iconFile="icon-homepage-big.svg"
        parentMenu={t('common.menu.homepage')}
        currentMenu={t('homepage.faq.title4')}
      />
      <FaqEditor
        data={res?.data}
        submit={submit}
      />
    </div>
  );
}

export default HomepageFaqEdit;
